'use client';

import { LottieLoadingSpinner } from '@frontend/components/animations';

export default function Loading() {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="flex flex-col items-center space-y-4">
        <LottieLoadingSpinner size={128} className="opacity-80" />
      </div>
    </div>
  );
}
